<template>
	<page title="competitionApprovalTitle">
		<template #pageContainer>
			<v-row>
				<v-col
					cols="12"
					md="12" class="py-1">
					<v-card>
						<v-data-table
							v-if="Competitions !== null"
							v-model="selected"
							:headers="headers"
							:items="Competitions"
							class="elevation-1"
							:page.sync="Pagination.currentPage"
							:items-per-page="400"
							:loading="loading || factsLoading"
							:loading-text="$t('text.userManagementLoading')"
							:server-items-length="Competitions.length"
							item-key="id"
							hide-default-footer
							:height="WindowSize.y - 450"
							show-expand
							single-expand
							@item-expanded="onItemExpand"
							fixed-header>
							<template #top>
								<v-container class="mt-0 pt-0 pb-0 mb-0">
									<v-row>
										<v-col cols="12" sm="3" lg="3">
											<v-btn-toggle dense
												color="primary"
												active-class="action-active">
												<v-btn
													:disabled=true
													color="primary"
													@click="newCompetitionApproval">
													<span class="hidden-sm-and-down">
														{{ $t(`text.newCompetitionApproval`) }}
													</span>
													<v-icon color="white">
														add
													</v-icon>
												</v-btn>
											</v-btn-toggle>
										</v-col>

										<v-col cols="12" sm="7" lg="7">
											<v-text-field outlined dense
												hide-details="auto"
												class="mt-0 pt-0"
												clearable
												v-model="tempQP.freetextSearch"
												:label="$t('text.name') + '/' + $t('text.location')"
												@keyup.enter.native="search">
											</v-text-field>
										</v-col>

										<v-col cols="12" sm="2" lg="2"
											align="right">
											<v-btn-toggle dense
												color="secondary"
												justify="center"
												active-class="action-active">
												<v-btn
													color="secondary"
													@click="search">
													<span class="hidden-sm-and-down">
														{{ $t(`text.searchButton`) }}
													</span>
													<v-icon color="white">
														search
													</v-icon>
												</v-btn>
											</v-btn-toggle>
										</v-col>
									</v-row>
									<v-row>
										<v-col cols="12" sm="12" lg="12">
										<v-expansion-panels>
											<v-expansion-panel>
												<v-expansion-panel-header><b>{{ $t(`text.additionalFilter`) }}</b></v-expansion-panel-header>
												<v-expansion-panel-content>
													<v-row>
														<v-col cols="12" sm="6" lg="2">
															<v-autocomplete outlined dense
																hide-details="auto"
																class="mt-0 pt-0"
																clearable
																v-model="tempQP.approvalState"
																:items="competitionState"
																:label="$t('text.approval')"
																@keyup.enter.native="search">
																<template v-slot:item="{ item }">
																	<v-icon :color="item.color" left>mdi-checkbox-blank-circle</v-icon>
																<v-list-item-content>
																	<v-list-item-title v-text="item.text"></v-list-item-title>
																</v-list-item-content>
																</template>
															</v-autocomplete>
														</v-col>
														<v-col cols="12" sm="6" lg="2">
															<v-autocomplete outlined dense
																hide-details="auto"
																class="mt-0 pt-0"
																clearable
																v-model="tempQP.year"
																:items="getDateDropdown"
																:label="$t('text.date')"
																@keyup.enter.native="search">
															</v-autocomplete>
														</v-col>
														<v-col cols="12" sm="6" lg="4">
															<v-autocomplete outlined dense
																hide-details="auto"
																class="mt-0 pt-0"
																clearable
																v-model="tempQP.regionGuid"
																:items="regionGuid.items"
																:label="$t('text.stateAssociation')"
																@keyup.enter.native="search">
															</v-autocomplete>
														</v-col>
													</v-row>
													<v-row>
														<v-col cols="12" sm="6" lg="2">
															<v-autocomplete outlined dense
																hide-details="auto"
																class="mt-0 pt-0"
																clearable
																v-model="tempQP.competitionType"
																:items="competitionApprovalType"
																:label="$t('text.type')"
																@keyup.enter.native="search">
															</v-autocomplete>
														</v-col>
														<v-col cols="12" sm="6" lg="2">
															<v-autocomplete outlined dense
																hide-details="auto"
																class="mt-0 pt-0"
																clearable
																v-model="tempQP.competitionCategory"
																:items="competitionCategory"
																:label="$t('text.category')"
																@keyup.enter.native="search">
															</v-autocomplete>
														</v-col>
														<v-col cols="12" sm="6" lg="2">
															<v-autocomplete outlined dense
																hide-details="auto"
																v-if="tempQP.regionGuid && areaGuid.items.length !== 0"
																class="mt-0 pt-0"
																clearable
																v-model="tempQP.areaGuid"
																:items="areaGuid.items"
																:label="$t('text.area')"
																@keyup.enter.native="search">
															</v-autocomplete>
														</v-col>
														<v-col cols="12" sm="6" lg="2">
															<v-autocomplete outlined dense
																hide-details="auto"
																v-if="tempQP.regionGuid && districtGuid.items.length !== 0"
																class="mt-0 pt-0"
																clearable
																v-model="tempQP.districtGuid"
																:items="districtGuid.items"
																:label="$t('text.district')"
																@keyup.enter.native="search">
															</v-autocomplete>
														</v-col>
													</v-row>
												</v-expansion-panel-content>
											</v-expansion-panel>
										</v-expansion-panels>
										</v-col>
									</v-row>
								</v-container>
							</template>
							<template #[`item.name`]="{ item }">
								<v-icon :color="getStatusColor(item.competitionState)" left>mdi-checkbox-blank-circle</v-icon>
								{{ item.name }}
							</template>
							<template #[`item.startDate`]="{ item }">
								{{ item.startDate | moment('DD.MM.YYYY') }}
							</template>
							<!-- <template #item.owner_Name="{ item }">
								{{ item.owner_Name }}
							</template> -->
							<template v-slot:expanded-item="{ headers, item }">
								<td :colspan="headers.length">
									<v-row>
										<v-col cols="12" sm="2" lg="2">
											<span class="header">{{$t('text.createdFrom')}}:</span>
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											{{item.createdByUsername}}
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											<span class="header">{{$t('text.createdOn')}}:</span>
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											<template v-if="!!item.createdAt">{{item.createdAt | moment('DD.MM.YYYY')}}</template>
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											<span class="header">{{$t('text.lastEditedOn')}}:</span>
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											<template v-if="!!item.changedAt">{{item.changedAt | moment('DD.MM.YYYY')}}</template>
										</v-col>
									</v-row>
									<v-row>
										<v-col cols="12" sm="2" lg="2" v-if="item.nationalCode">
											<span class="header">{{$t('text.competitionId')}}:</span>
										</v-col>
										<v-col cols="12" sm="2" lg="2" v-if="item.nationalCode">
											{{item.nationalCode}}
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											<span class="header">{{$t('text.type')}}:</span>
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											{{getApprovalTypeText(item.competitionApprovalType)}}
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											<span class="header">{{$t('text.category')}}:</span>
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											{{getCompetitionCategoryText(item.competitionCategory)}}
										</v-col>
									</v-row>
									<v-row>
										<v-col cols="12" sm="2" lg="2">
											<span class="header">{{$t('text.country')}}:</span>
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											{{item.country}}
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											<span class="header">{{$t('text.location')}}:</span>
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											{{item.eventLocation_Town}}
										</v-col>
										<v-col cols="12" sm="4" lg="4"></v-col>
									</v-row>
									<v-row>
										<v-col cols="12" sm="2" lg="2">
											<span class="header">{{$t('text.stateAssociation')}}:</span>
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											{{item.eventLocation_RegionName ? item.eventLocation_RegionName : '' }}
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											<span class="header">{{$t('text.areaAssociation')}}:</span>
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											{{item.eventLocation_AreaName}}
										</v-col>
										<v-col cols="12" sm="4" lg="4">
										</v-col>
									</v-row>
									<v-row>
										<v-col cols="12" sm="2" lg="2">
											<span class="header">{{$t('text.organisator')}}:</span>
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											{{item.ownerOrganizationName}}
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											<span class="header">{{$t('text.homepage')}}:</span>
										</v-col>
										<v-col cols="12" sm="2" lg="2">
											<a v-if="item.hp" :href="item.contact_Website" target='_blank'>item.contact_Website</a>
										</v-col>
										<v-col cols="12" sm="4" lg="4">
										</v-col>
									</v-row>
									<v-row v-for="(a, i) in item.approvals" :key="i + '-ap'">
										<v-col>
											<v-icon :color="getApprovalState(a.approvalState)">mdi-checkbox-blank-circle</v-icon>{{ a.organization }} <span v-if="a.changedAt">({{a.changedAt | moment('DD.MM.YYYY')}})</span><br>
											<p v-if="a.reason"><b>{{ $t(`text.headerReason`) }}:</b> {{a.reason}}</p>
										</v-col>
									</v-row>
									<v-row>
										<v-col cols="12" sm="12" lg="9">
											<v-menu offset-y>
												<template v-slot:activator="{ on, attrs }">
												<v-btn-toggle
													color="secondary"
													justify="center"
													dark
													active-class="action-active">
													<v-btn
														v-bind="attrs"
														v-on="on">
														{{ $t('text.headerActions') }}
													</v-btn>
												</v-btn-toggle>
												</template>
												<v-list>
													<v-list-item>
														<v-btn
															@click="viewCompetition(item.id)"
															color="secondary">
																{{ $t('text.showDetails') }}
														</v-btn>
													</v-list-item>
													<v-list-item>
														<v-btn
															:disabled=true
															color="secondary"
															@click="editCompetition(item)">
															<span class="hidden-sm-and-down">
																{{$t('text.editLow')}}
															</span>
														</v-btn>
													</v-list-item>
													<v-list-item>
														<v-btn
															:disabled=true
															color="secondary"
															@click="cancleCompetition(item.id)">
															<span class="hidden-sm-and-down">
																{{$t('text.cancel')}}
															</span>
														</v-btn>
													</v-list-item>
													<!-- <v-list-item>
														<v-btn
															color="secondary"
															@click="requestDeleteCompetition(item.id)">
															<span class="hidden-sm-and-down">
																{{$t('text.delete')}}
															</span>
														</v-btn>
													</v-list-item> -->
													<v-list-item>
														<v-btn
															color="secondary"
															:disabled="!competitionPassed(item.startDate) || !!item.billing_Filename"
															@click="editFinisher(item.id)">
															<span class="hidden-sm-and-down">
																{{$t('text.finisherNumbers')}}
															</span>
														</v-btn>
													</v-list-item>
													<v-list-item>
														<v-btn															
															:disabled=true
															@click="copyCompetition(item.id)"
															color="secondary">
															<span class="hidden-sm-and-down">
																{{$t('text.copy')}}
															</span>
														</v-btn>
													</v-list-item>
													<v-list-item>
														<v-btn
															:disabled=true
															@click="addFile(item.id)"
															color="secondary">
															<span class="hidden-sm-and-down">
																{{$t('text.addFile')}}
															</span>
														</v-btn>
													</v-list-item>
													<v-list-item>
														<v-btn
															:disabled="!item.billing_Filename"
															@click="loadInvoice(item)"
															color="secondary">
															<span class="hidden-sm-and-down">
																{{$t('text.invoice')}}
															</span>
														</v-btn>
													</v-list-item>
												</v-list>
											</v-menu>
										</v-col>
										<v-col cols="12" sm="12" lg="3">
											<v-btn-toggle
												color="secondary"
												justify="center"
												active-class="action-active">
												<v-btn
													v-if="item.competitionState === 2"
													color="secondary"
													@click="requestApproval(item.id)">
													{{ $t(`text.insertCompetition`) }}
												</v-btn>
												<v-btn
													v-if="item.competitionState === 1 && IsApprover"
													color="secondary"
													@click="editState(item.id)">
													<span class="hidden-sm-and-down">
														{{$t('text.approceDecline')}}
													</span>
												</v-btn>
												<v-btn
													v-if="IsApprover"
													@click="generateInvoice(item)"
													color="secondary">
													<span class="hidden-sm-and-down">
														{{$t('text.generate_invoice')}}
													</span>
													</v-btn>
											</v-btn-toggle>
										</v-col>
									</v-row>
								</td>
							</template>
						</v-data-table>


						<pagination
							:currentPage="Pagination.currentPage"
							:totalPages="Pagination.totalPages"
							:pageSize="queryParameters.pageSize"
							@current="current"
							@pageSizeChanged="pageSizeChanged">
						</pagination>
					</v-card>

					<pop-up v-model="confirmDelete"
						:show="showConfirmDelete"
						:props="deletePopupProps"
						title="dialogText.uSure"
						text="editCompApprovalDeleteHINT"
						type="confirm"
						width="70%"
						@close="deleteCompetition">
					</pop-up>
				</v-col>
			</v-row>
		</template>
	</page>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import axios from 'axios';
import Page from '../general/Page.vue';
import Pagination from '../general/Pagination.vue';
import PopUp from '../general/PopUp.vue';


import getCompetitionState from '../models/competitionState';
import getApprovalState from '../models/approvalState';
import getCompetitionApprovalType from '../models/competitionApprovalType';
import getCompetitionCategory from '../models/competitionCategory';

import compApprovalActions from '../store/actions/compApproval';
import organizationActions from '../store/actions/organization';
import namespace from '../store/namespace';

import modelState from '../mixins/modelState';

class TempCompApprovalQueryParameter {
	constructor(qp) {
		if (qp !== undefined) {
			this.approvalState = qp.approvalState;
			this.year = qp.year;
			this.competitionType = qp.competitionType;
			this.regionGuid = qp.regionGuid;
			this.areaGuid = qp.areaGuid;
			this.districtGuid = qp.districtGuid;
			this.competitionCategory = qp.competitionCategory;
			this.freetextSearch = qp.freetextSearch;
		}
	}
}

class CompApprovalQueryParameter {
	constructor(qp) {
		if (qp !== undefined) {
			this.approvalState = qp.approvalState;
			this.year = qp.year;
			this.competitionType = qp.competitionType;
			this.regionGuid = qp.regionGuid;
			this.areaGuid = qp.areaGuid;
			this.districtGuid = qp.districtGuid;
			this.competitionCategory = qp.competitionCategory;
			this.freetextSearch = qp.freetextSearch;
			this.pageNumber = qp.pageNumber;
			this.pageSize = qp.pageSize;
		} else {
			this.pageNumber = 1;
			this.pageSize = 10;
			this.freetextSearch = '';
			this.approvalState = null;
			this.year = null;
			this.competitionType = null;
			this.regionGuid = null;
			this.areaGuid = null;
			this.districtGuid = null;
			this.competitionCategory = null;
		}
	}

	updateTempData(tempQP) {
		this.freetextSearch = tempQP.freetextSearch;
		this.approvalState = tempQP.approvalState;
		this.year = tempQP.year;
		this.competitionType = tempQP.competitionType;
		this.regionGuid = tempQP.regionGuid;
		this.areaGuid = tempQP.areaGuid;
		this.districtGuid = tempQP.districtGuid;
		this.competitionCategory = tempQP.competitionCategory;
	}
}

export default {
	name: 'CompetitionApproval',
	mixins: [modelState],
	components: {
		Page,
		Pagination,
		PopUp,
	},
	data() {
		return {
			headers: [
				{
					text: this.$i18n.t('text.headerCompetitionName'), align: 'left', value: 'name', sortable: false,
				},
				{
					text: this.$i18n.t('text.headerCompetitionDate'), align: 'left', value: 'startDate', sortable: false, width: 50,
				},
				{
					text: this.$i18n.t('text.organisator'), align: 'left', value: 'ownerOrganizationName', sortable: false,
				},
				{
					text: this.$i18n.t('text.headerCompetitionLocation'), align: 'left', value: 'eventLocation_Town', sortable: false, width: 250,
				},
			],
			loading: true,
			factsLoading: false,
			orgLoading: false,
			dialogItem: null,
			isLastRole: false,
			selected: [],
			deleteWarnings: [],
			organizations: [],
			regionGuid: {
				items: [],
				loading: false,
			},
			areaGuid: {
				items: [],
				loading: false,
			},
			districtGuid: {
				items: [],
				loading: false,
			},
			showConfirmDelete: false,
			confirmDelete: 1,
			deletePopupProps: null,
			queryParameters: new CompApprovalQueryParameter(),
			tempQP: new TempCompApprovalQueryParameter(),
		};
	},
	async mounted() {
		if (localStorage.getItem('compApprQPApp')) {
			this.queryParameters = new CompApprovalQueryParameter(JSON.parse(localStorage.getItem('compApprQPApp')));
			this.tempQP = new TempCompApprovalQueryParameter(this.queryParameters);
		} else {
			localStorage.setItem('compApprQPApp', JSON.stringify(this.queryParameters));
		}
		this.REMOVE_COMPETITION();
		this.SET_COMPETITION(null);
		if (this.CompApprLinks.length === undefined || this.CompApprLinks.length === 0) {
			await this.GET_COMP_APPROVAL_LINKS();
		}
		// if (localStorage.getItem('compApprQP')) this.queryParameters = JSON.parse(localStorage.getItem('compApprQP'));
		await this.loadData();
		this.getRegionOrganization();
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.COMPETITIONAPPROVAL, ['CompApprLinks', 'Competitions', 'Pagination']),
		...mapGetters(namespace.ORGANIZATION, ['HasOrganization', 'Organization']),
		...mapGetters(namespace.USERROLE, ['Links']),
		...mapGetters(namespace.USER, ['IsApprover']),
		getDateDropdown() {
			const ret = [];
			const to = new Date().getFullYear() + 5;
			for (let i = 2019; i <= to; i += 1) {
				ret.push(i);
			}
			return ret;
		},
		competitionState() {
			return getCompetitionState(this);
		},
		approvalState() {
			return getApprovalState(this).filter(x => x.value !== null);
		},
		competitionApprovalType() {
			return getCompetitionApprovalType(this);
		},
		competitionCategory() {
			return getCompetitionCategory(this, 1);
		},
		getStatusColor: state => id => (state.competitionState.find(x => x.value === id)).color,
		getApprovalState: state => id => (state.approvalState.find(x => x.value === id)).color,
	},
	watch: {
		'queryParameters.regionGuid': function () {
			this.getAreaOrganization();
			this.getDistrictOrganization();
		},
		queryParameters: {
			deep: true,
			handler() {
				localStorage.setItem('compApprQPApp', JSON.stringify(this.queryParameters));
			},
		},
	},
	methods: {
		...mapActions(namespace.COMPETITIONAPPROVAL, [
			compApprovalActions.GET_COMP_APPROVAL_LINKS,
			compApprovalActions.NEW_COMP_APPROVAL,
			compApprovalActions.GET_COMP_APPROVAL_LIST,
			compApprovalActions.GET_COMPETITION_BY_GUID,
			compApprovalActions.COPY_COMP_APPROVAL,
			compApprovalActions.REQUEST_COMP_APPROVAL,
			compApprovalActions.DELETE_COMPETITION,
			compApprovalActions.CREATE_RECEIPT,
		]),
		...mapActions(namespace.ORGANIZATION, [
			organizationActions.GET_ORGANIZATIONS_BY_NAME,
			organizationActions.GET_ORGANIZATION_BY_GUID,
			organizationActions.GET_ORGANIZATIONS_BY_TYPE,
			organizationActions.GET_ORGANIZATIONS_BY_TYPE_PARENT,
		]),
		...mapMutations(namespace.COMPETITIONAPPROVAL, [
			compApprovalActions.REMOVE_COMPETITION,
			compApprovalActions.SET_COMPETITION,
		]),
		competitionPassed(date) {
			const today = new Date();
			const cDate = new Date(date);
			return today >= cDate;
		},
		async requestApproval(cGuid) {
			const link = this.CompApprLinks.find(x => x.rel === 'request_comp_approval');
			if (link) {
				await this.REQUEST_COMP_APPROVAL({ link, cGuid });
				await this.loadData();
			}
		},
		async getRegionOrganization() {
			this.regionGuid.loading = true;
			this.regionGuid.items = await this.GET_ORGANIZATIONS_BY_TYPE('Region');
			this.regionGuid.loading = false;
		},
		async getAreaOrganization() {
			if (!this.queryParameters.regionGuid) {
				this.queryParameters.areaGuid = null;
				return;
			}
			this.areaGuid.loading = true;
			this.areaGuid.items = await this.GET_ORGANIZATIONS_BY_TYPE_PARENT({ type: 'Area', parent: this.queryParameters.regionGuid });
			this.areaGuid.loading = false;
		},
		async getDistrictOrganization() {
			if (!this.queryParameters.regionGuid) {
				this.queryParameters.districtGuid = null;
				return;
			}
			this.districtGuid.loading = true;
			this.districtGuid.items = await this.GET_ORGANIZATIONS_BY_TYPE_PARENT({ type: 'District', parent: this.queryParameters.regionGuid });
			this.districtGuid.loading = false;
		},
		async pageSizeChanged(newPageSize) {
			this.queryParameters.pageSize = newPageSize;
			const maxPage = Math.ceil(this.Pagination.totalCount / newPageSize);
			this.queryParameters.pageNumber = maxPage < this.Pagination.currentPage ? maxPage : this.Pagination.currentPage;

			await this.loadData();
		},
		newCompetitionApproval() {
			this.$router.push({ name: 'newcompetitionapproval' });
		},
		async onItemExpand({ item, value }) {
			this.factsLoading = true;
			if (value) {
				const link = this.CompApprLinks.find(x => x.rel === 'get_by_id');
				if (link) {
					await this.GET_COMPETITION_BY_GUID({ link, cGuid: item.id });
				}
			}
			this.factsLoading = false;
		},
		async loadData() {
			this.loading = true;
			try {
				const link = this.CompApprLinks.find(x => x.rel === 'get_by_org');
				if (link) {
					await this.GET_COMP_APPROVAL_LIST({ link, oGuid: this.Organization, queryParameters: this.queryParameters });
				}
			} finally {
				this.loading = false;
			}
		},
		async search() {
			this.queryParameters.updateTempData(this.tempQP);
			localStorage.setItem('compApprQPApp', JSON.stringify(this.queryParameters));
			this.queryParameters.pageNumber = 1;
			await this.loadData();
		},
		async current(newPage) {
			this.queryParameters.pageNumber = newPage;
			await this.loadData();
		},
		getApprovalTypeText(val) {
			if (val === undefined) return '';
			const obj = this.competitionApprovalType.find(x => x.value === val);
			return obj ? obj.text : '';
		},
		getCompetitionCategoryText(val) {
			if (val === undefined) return '';
			const obj = this.competitionCategory.find(x => x.value === val);
			return obj ? obj.text : '';
		},
		editCompetition(comp) {
			let r = true;
			// eslint-disable-next-line no-restricted-globals, no-alert
			if ([1, 3].includes(comp.competitionState)) r = confirm(this.$i18n.t('text.editCompApprovalREQUEST'));
			if (r === true) {
				this.$router.push({
					name: 'editcompetitionapproval',
					params: { cGuid: comp.id },
				});
			}
		},
		async copyCompetition(cGuid) {
			this.loading = true;
			const link = this.CompApprLinks.find(x => x.rel === 'copy_competition');

			if (link) {
				try {
					this.modelState = {};
					const data = await this.COPY_COMP_APPROVAL({ link, cGuid });
					if (data.id) {
						this.$router.push({
							name: 'editcompetitionapproval',
							params: { cGuid: data.id },
						});
					}
				} catch (e) {
					console.log(e);
					if (e.response.status === 422) {
						this.modelState = e.response.data;
						if (this.modelError()) {
							throw new Error(this.modelError());
						}
					}

					throw e;
				} finally {
					this.loading = false;
				}
			}
			this.loading = false;
		},
		editFinisher(cGuid) {
			this.$router.push({
				name: 'compFinisherDetailView',
				params: { cGuid },
			});
		},
		addFile(cGuid) {
			this.$router.push({
				name: 'compApprovalAttachmentsOnly',
				params: { cGuid },
			});
		},
		viewCompetition(cGuid) {
			this.$router.push({
				name: 'compApprovalDetailView',
				params: { cGuid },
			});
		},
		editState(cGuid) {
			this.$router.push({
				name: 'CompetitionApprovalEditState',
				params: { cGuid },
			});
		},
		cancleCompetition(cGuid) {
			this.$router.push({
				name: 'CompetitionApprovalCancel',
				params: { cGuid },
			});
		},
		requestDeleteCompetition(cGuid) {
			this.deletePopupProps = { cGuid };
			this.showConfirmDelete = true;
			this.confirmDelete = 1;
		},
		async deleteCompetition(props) {
			this.showConfirmDelete = false;
			if (this.confirmDelete) {
				const link = this.CompApprLinks.find(x => x.rel === 'delete_competition');
				if (link) {
					try {
						this.modelState = {};
						await this.DELETE_COMPETITION({ link, cGuid: props.cGuid });
					} catch (e) {
						console.log(e);
						if (e.response.status === 422) {
							this.modelState = e.response.data;
							if (this.modelError()) {
								throw new Error(this.modelError());
							}
						}

						throw e;
					} finally {
						this.loading = false;
					}
				}
				this.loadData();
			}
		},
		loadInvoice(item) {
			this.downloadWithAxios(`${window.location.origin}/${item.billing_Filename}`);
		},
		async generateInvoice(props) {
			const link = this.CompApprLinks.find(x => x.rel === 'create_receipt');
			if (link) {
				try {
					this.loading = true;
					const data = await this.CREATE_RECEIPT({ link, cGuid: props.id });
					if (data.receiptInformation == true) {
						props.billing_Filename = data.filename;
					} else {
						throw new Error('Rechnung konnte nicht generiert werden');
					}
				} catch (e) {
					console.log(e);
					if (e.response !== undefined && e.response.status === 422) {
						this.modelState = e.response.data;
						if (this.modelError()) {
							throw new Error(this.modelError());
						}
					}

					throw e;
				} finally {
					this.loading = false;
				}
			}
		},
		forceFileDownload(response) {
			const url = window.URL.createObjectURL(new Blob([response.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'receip.pdf');
			document.body.appendChild(link);
			link.click();
		},

		downloadWithAxios(url) {
			axios({
				method: 'get',
				url,
				responseType: 'arraybuffer',
			})
				.then((response) => {
					this.forceFileDownload(response);
				})
				.catch(() => console.log('error occured'));
		},
	},
};
</script>

<style lang="scss" scoped>
.action-active {
	border-color: rgba(0,0,0,.12) !important;
	color: rgb(255, 255, 255) !important;
	opacity: 0.8 !important;

	&:before {
		opacity: 0 !important;
	}
}

.header{
	font-weight: bold;
}

p {
	margin:0px!important;
}
</style>
